import { render } from "./painting-3.vue?vue&type=template&id=a410b46c&scoped=true"
import script from "./painting-3.vue?vue&type=script&lang=js"
export * from "./painting-3.vue?vue&type=script&lang=js"

import "./painting-3.vue?vue&type=style&index=0&id=a410b46c&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a410b46c"]])

export default __exports__